// src/TechInfo.js

import React, { useState } from 'react';
import './TechInfo.css';

const techData = {
    "Hardware": {
      "CPU": {
        uses: "Executes instructions to perform tasks.",
        importance: "The brain of the computer, essential for processing data.",
        versions: ["Intel Core i9", "AMD Ryzen 9", "Apple M1"],
        otherSpecialities: [
          "Multi-core processing for better performance.",
          "Overclocking capabilities for increased speed.",
          "Integrated graphics for basic visual processing."
        ]
      },
      "RAM": {
        uses: "Stores data temporarily for quick access.",
        importance: "Crucial for multitasking and running applications smoothly.",
        versions: ["DDR4", "DDR5", "LPDDR4"],
        otherSpecialities: [
          "High-speed data transfer rates.",
          "Low power consumption in mobile devices.",
          "ECC memory for error detection and correction."
        ]
      },
      "GPU": {
        uses: "Renders graphics and accelerates computing.",
        importance: "Essential for gaming, video editing, and AI tasks.",
        versions: ["NVIDIA RTX 3080", "AMD Radeon RX 6800", "Apple M1 GPU"],
        otherSpecialities: [
          "Ray tracing for realistic lighting effects.",
          "Dedicated VRAM for better performance.",
          "Support for multiple monitors."
        ]
      },
      "Motherboard": {
        uses: "Houses and connects all the components of a computer.",
        importance: "Essential for communication between all hardware components.",
        versions: ["ATX", "Micro-ATX", "Mini-ITX"],
        otherSpecialities: [
          "Supports various CPU sockets.",
          "Multiple expansion slots for GPUs, sound cards.",
          "Integrated components like sound and network cards."
        ]
      },
      "Power Supply Unit (PSU)": {
        uses: "Provides power to all components of the computer.",
        importance: "Ensures stable and reliable power delivery.",
        versions: ["ATX", "SFX", "TFX"],
        otherSpecialities: [
          "Different wattages to support various builds.",
          "Modular cables for easy management.",
          "Efficiency ratings like 80 Plus Bronze, Gold, Platinum."
        ]
      },
      "Storage Drive (HDD/SSD)": {
        uses: "Stores the operating system, software, and data.",
        importance: "Crucial for system performance and data storage.",
        versions: ["SATA SSD", "NVMe SSD", "HDD"],
        otherSpecialities: [
          "SSD for faster read/write speeds.",
          "HDD for larger storage capacities at lower cost.",
          "Hybrid drives combining SSD and HDD features."
        ]
      },
      "Cooling System (Fan/Heatsink)": {
        uses: "Maintains optimal temperatures for components.",
        importance: "Prevents overheating and extends lifespan of hardware.",
        versions: ["Air Coolers", "Liquid Coolers", "Thermoelectric Coolers"],
        otherSpecialities: [
          "RGB lighting for aesthetics.",
          "Quiet operation with efficient cooling.",
          "Custom loop liquid cooling for enthusiasts."
        ]
      },
      "Case": {
        uses: "Holds and protects all components of a computer.",
        importance: "Ensures proper airflow and cable management.",
        versions: ["Mid Tower", "Full Tower", "Mini Tower"],
        otherSpecialities: [
          "Tool-less design for easy installation.",
          "Tempered glass panels for aesthetics.",
          "Sound dampening materials."
        ]
      },
      "Network Interface Card (NIC)": {
        uses: "Enables the computer to connect to a network.",
        importance: "Essential for internet and network connectivity.",
        versions: ["Ethernet", "Wi-Fi", "Bluetooth"],
        otherSpecialities: [
          "High-speed Ethernet ports.",
          "Dual-band Wi-Fi for better connectivity.",
          "Integrated Bluetooth for wireless peripherals."
        ]
      },
      "Sound Card": {
        uses: "Processes and outputs audio signals.",
        importance: "Enhances audio quality for media and communication.",
        versions: ["Integrated", "External USB", "PCIe"],
        otherSpecialities: [
          "Surround sound support.",
          "High-fidelity audio output.",
          "Integrated amplifiers for headphones."
        ]
      },
      "Optical Drive": {
        uses: "Reads and writes data from optical discs like CDs, DVDs, and Blu-rays.",
        importance: "Useful for media playback and data backup.",
        versions: ["CD/DVD Burner", "Blu-ray Drive", "External USB Drive"],
        otherSpecialities: [
          "Multi-format support.",
          "High-speed burning capabilities.",
          "Slim and portable designs."
        ]
      },
      "Peripheral Devices": {
        uses: "External devices used to interact with the computer.",
        importance: "Enhances user experience and functionality.",
        versions: ["Keyboards", "Mice", "Monitors"],
        otherSpecialities: [
          "Mechanical and membrane keyboards.",
          "High-DPI mice for gaming.",
          "Ultra-wide and 4K monitors."
        ]
      },

            "Monitor": {
            uses: "Displays visual output from the computer.",
            importance: "Essential for interacting with the computer.",
            versions: ["1080p", "1440p", "4K"],
            otherSpecialities: [
              "High refresh rates for smooth visuals.",
              "Wide color gamut for accurate colors.",
              "Curved screens for immersive experience."
            ]
          },
          "Keyboard": {
            uses: "Input device for typing.",
            importance: "Allows user interaction and command input.",
            versions: ["Mechanical", "Membrane", "Wireless"],
            otherSpecialities: [
              "Backlit keys for visibility.",
              "Programmable macro keys.",
              "Ergonomic design for comfort."
            ]
          },
          "Mouse": {
            uses: "Input device for pointing and clicking.",
            importance: "Enables precise control and navigation.",
            versions: ["Optical", "Laser", "Wireless"],
            otherSpecialities: [
              "High DPI for sensitivity.",
              "Customizable buttons.",
              "Ergonomic design."
            ]
          },
          "Printer": {
            uses: "Produces physical copies of documents.",
            importance: "Essential for printing documents, photos, etc.",
            versions: ["Inkjet", "Laser", "All-in-One"],
            otherSpecialities: [
              "High-quality color printing.",
              "Wireless printing capabilities.",
              "Multi-function (print, scan, copy, fax)."
            ]
          },
          "Network Card": {
            uses: "Enables network connectivity.",
            importance: "Essential for internet and network access.",
            versions: ["Ethernet", "Wi-Fi", "Bluetooth"],
            otherSpecialities: [
              "High-speed data transfer rates.",
              "Dual-band Wi-Fi support.",
              "Integrated antennas for better reception."
            ]
          }
        },
        "Software": {
          "Operating System": {
            uses: "Manages hardware and software resources.",
            importance: "Provides a user interface and controls system operations.",
            versions: ["Windows 10", "macOS Big Sur", "Ubuntu Linux"],
            otherSpecialities: [
              "Built-in security features.",
              "Support for a wide range of applications.",
              "Regular updates for improved functionality."
            ]
          },
          "Office Suite": {
            uses: "Provides productivity tools for document creation and management.",
            importance: "Essential for business and educational purposes.",
            versions: ["Microsoft Office 365", "Google Workspace", "LibreOffice"],
            otherSpecialities: [
              "Cloud storage and collaboration.",
              "Wide range of applications (Word, Excel, PowerPoint).",
              "Compatibility with multiple file formats."
            ]
          },
          "Web Browser": {
            uses: "Enables access to the internet and web applications.",
            importance: "Crucial for browsing, communication, and online services.",
            versions: ["Google Chrome", "Mozilla Firefox", "Microsoft Edge"],
            otherSpecialities: [
              "Extension support for enhanced functionality.",
              "Cross-platform availability.",
              "Privacy and security features."
            ]
          },
          "Antivirus Software": {
            uses: "Protects the computer from malware and viruses.",
            importance: "Ensures the security and integrity of data.",
            versions: ["Norton Antivirus", "McAfee", "Avast"],
            otherSpecialities: [
              "Real-time protection.",
              "Regular updates for new threats.",
              "System optimization tools."
            ]
          },
          "Media Player": {
            uses: "Plays audio and video files.",
            importance: "Provides entertainment and media playback.",
            versions: ["VLC Media Player", "Windows Media Player", "QuickTime"],
            otherSpecialities: [
              "Supports a wide range of formats.",
              "Streaming capabilities.",
              "Customization options for playback."
            ]
          },
          "Graphics Software": {
            uses: "Creates and edits images and graphics.",
            importance: "Essential for design and creative work.",
            versions: ["Adobe Photoshop", "CorelDRAW", "GIMP"],
            otherSpecialities: [
              "Advanced editing tools.",
              "Support for multiple file formats.",
              "Layers and filters for creativity."
            ]
          },
          "Database Management System": {
            uses: "Manages databases and data storage.",
            importance: "Crucial for handling large amounts of data.",
            versions: ["MySQL", "PostgreSQL", "Oracle Database"],
            otherSpecialities: [
              "Data security and integrity.",
              "Support for complex queries.",
              "Scalability for large datasets."
            ]
          },
          "IDE (Integrated Development Environment)": {
            uses: "Provides tools for software development.",
            importance: "Enhances productivity and coding efficiency.",
            versions: ["Visual Studio Code", "Eclipse", "IntelliJ IDEA"],
            otherSpecialities: [
              "Syntax highlighting.",
              "Debugging tools.",
              "Integrated version control."
            ]
          },
          "Virtualization Software": {
            uses: "Creates and manages virtual machines.",
            importance: "Enables running multiple operating systems on one hardware.",
            versions: ["VMware", "VirtualBox", "Hyper-V"],
            otherSpecialities: [
              "Snapshot capabilities.",
              "Resource management.",
              "Cross-platform compatibility."
            ]
          },
          "Project Management Software": {
            uses: "Helps plan, organize, and manage projects.",
            importance: "Ensures efficient project execution and collaboration.",
            versions: ["Trello", "Asana", "Microsoft Project"],
            otherSpecialities: [
              "Task assignment and tracking.",
              "Gantt charts and timelines.",
              "Collaboration tools."
            ]
          },
          "Browser": {
            uses: "Enables access to the internet and web applications.",
            importance: "Crucial for browsing, communication, and online services.",
            versions: ["Google Chrome", "Mozilla Firefox", "Microsoft Edge"],
            otherSpecialities: [
              "Extension support for enhanced functionality.",
              "Cross-platform availability.",
              "Privacy and security features."
            ]
          },
          "Email Client": {
            uses: "Manages email communication.",
            importance: "Essential for business and personal communication.",
            versions: ["Microsoft Outlook", "Mozilla Thunderbird", "Apple Mail"],
            otherSpecialities: [
              "Integration with calendars and contacts.",
              "Support for multiple email accounts.",
              "Advanced filtering and organization options."
            ]
          }
        }
      };
      
  

const TechInfo = () => {
  const [selectedCategory, setSelectedCategory] = useState('Hardware');
  const [selectedItem, setSelectedItem] = useState('CPU');
  const [readAloud, setReadAloud] = useState(false);

  const handleCategoryChange = (e) => {
    const category = e.target.value;
    setSelectedCategory(category);
    setSelectedItem(Object.keys(techData[category])[0]);
  };

  const handleItemChange = (e) => {
    setSelectedItem(e.target.value);
  };

  const handleReadAloud = () => {
    const item = techData[selectedCategory][selectedItem];
    const utterance = new SpeechSynthesisUtterance(
      `The ${selectedItem} is used for ${item.uses}. It is important because ${item.importance}. Different versions include ${item.versions.join(", ")}. Other specialities are ${item.otherSpecialities.join(", ")}.`
    );
    speechSynthesis.speak(utterance);
    setReadAloud(true);
  };

  const item = techData[selectedCategory][selectedItem];

  return (
    <div className="tech-info">
      <h1>Computer Basics - Both Hardware & Software</h1>
      <div>
        <label>
          Select Category:
          <select value={selectedCategory} onChange={handleCategoryChange}>
            {Object.keys(techData).map((category) => (
              <option key={category} value={category}>{category}</option>
            ))}
          </select>
        </label>
      </div>
      <div>
        <label>
          Select Item:
          <select value={selectedItem} onChange={handleItemChange}>
            {Object.keys(techData[selectedCategory]).map((item) => (
              <option key={item} value={item}>{item}</option>
            ))}
          </select>
        </label>
      </div>
      <div className="info">
        <h2>{selectedItem}</h2>
        <p><strong>Uses:</strong> {item.uses}</p>
        <p><strong>Importance:</strong> {item.importance}</p>
        <p><strong>Versions:</strong> {item.versions.join(", ")}</p>
        <p><strong>Other Specialities:</strong></p>
        <ul>
          {item.otherSpecialities.map((speciality, index) => (
            <li key={index}>{speciality}</li>
          ))}
        </ul>
      </div>
      <button onClick={handleReadAloud}>Read Aloud</button>
    </div>
  );
};

export default TechInfo;
